import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles, useTheme } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import useMobileLayout from 'Hooks/useMobileLayout';
import classNames from 'classnames';

const useStyles = makeStyles(theme => ({
  timelineConnectorDimensions: {
    height: 'calc(50% - 15px)',
    marginLeft: theme.spacing(0.75),
    flexGrow: 1,
  },
  timelineConnectorDimensionsMobile: {
    height: '50px',
    margin: theme.spacing(1, 0, 1, 0),
  },
  timelineConnector: {
    borderLeftColor: theme.palette.facet.primaryBlue,
    borderLeftStyle: 'dashed',
    borderLeftWidth: '1px',
  },
}));


export default function TimelineConnector({ isVisible }) {
  const theme = useTheme();
  const classes = useStyles(theme);
  const isMobile = useMobileLayout();

  return (

    <div className={classNames({
      [classes.timelineConnector]: isVisible,
      [classes.timelineConnectorDimensions]: !isMobile,
      [classes.timelineConnectorDimensionsMobile]: isMobile,
    })}
    />

  );
}

TimelineConnector.defaultProps = {
  isVisible: true,
};

TimelineConnector.propTypes = {
  isVisible: PropTypes.bool,
};
